import { TimelineEventModel } from '@models/Timeline';
import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimelineDeviceName } from '../../hooks/useTimelineDeviceName';
import { TimelineCard } from './TimelineCard';
import TimelineDevicePhoto from './TimelineDevicePhoto';

export const TrainingMode = ({ event, active }: { event: TimelineEventModel; active: boolean }) => {
  const { t } = useTranslation();
  const deviceName = useTimelineDeviceName(event.devices);
  const parsedData = useMemo(() => {
    return JSON.parse(event.data);
  }, [event.data]);

  const text = useMemo(() => {
    const { mode } = parsedData;

    if (mode) {
      return t('notification_training_mode', {
        devicename: deviceName,
        mode,
      });
    }

    return t('notification_no_training_mode', {
      devicename: deviceName,
    });
  }, [parsedData, deviceName, t]);

  return (
    <TimelineCard
      active={active}
      text={text}
      date={event.created_at}
      image={
        <TimelineDevicePhoto
          active={active}
          event={event}
        />
      }
    />
  );
};
